import PropTypes from 'prop-types'
import React from 'react'
import { useField } from 'react-final-form'
import TextField from '../../molecules/fields/TextField'
import CheckboxField from '../../molecules/fields/CheckboxField'
import Value from '../../molecules/Value'
import ManualEntryPayload from './ManualEntryPayload'
import * as validations from '../../../utils/validations'

const SubtitleQuestionFields = ({ baseName }) => {
  const { input: description } = useField(`${baseName}.payload.description`)

  const handleDescriptionToggle = () => {
    description.onChange(null)
  }

  return (
    <>
      <TextField
        label="Etiqueta del subtítulo"
        size="full"
        name={`${baseName}.payload.label`}
        validate={validations.required()}
        margin="none"
        capsLockInfo
        maxLength={100}
      />
      <div className="w-full mt-2">
        <CheckboxField
          className="ml-0.5"
          name={`${baseName}.payload.has_description`}
          margin="dense"
          label="Agregar descripción"
          onChange={handleDescriptionToggle}
          noYpadding
        />
        <Value name={`${baseName}.payload.has_description`}>
          {({ value }) =>
            value && (
              <TextField
                name={`${baseName}.payload.description`}
                margin="dense"
                size="full"
                validate={validations.required()}
                maxLength={280}
                element="textarea"
                rows={3}
                className="resize-none"
              />
            )
          }
        </Value>
      </div>
      <ManualEntryPayload baseName={baseName} margin="none" size="full" />
    </>
  )
}
export default SubtitleQuestionFields

SubtitleQuestionFields.propTypes = {
  baseName: PropTypes.string
}
